export const capitalize = (texto: string): string => {
    return texto && texto[0].toUpperCase() + texto.slice(1).toLowerCase();
}